import { render, staticRenderFns } from "./DeviationsFromRecommendedPrice.vue?vue&type=template&id=39c3a430&scoped=true"
import script from "./DeviationsFromRecommendedPrice.vue?vue&type=script&lang=js"
export * from "./DeviationsFromRecommendedPrice.vue?vue&type=script&lang=js"
import style0 from "./DeviationsFromRecommendedPrice.vue?vue&type=style&index=0&id=39c3a430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3a430",
  null
  
)

export default component.exports